export default "/dist/files/icone_video_galerie.4be0a306df398b7dd53f8b89b9744498.svg";